import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { isAdminEmail } from '../../lib/adminAccess';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiresAdmin = false,
}) => {
  const { isAuthReady, isProfileReady, user, userProfile } = useAuth();
  const location = useLocation();

  // Show loading while auth state is being determined
  if (!isAuthReady) {
    return (
      <div className="min-h-screen bg-st-dark flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-st-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-st-muted">Loading...</p>
        </div>
      </div>
    );
  }

  if (user && !isProfileReady) {
    return (
      <div className="min-h-screen bg-st-dark flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-st-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-st-muted">Loading profile...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to home and open auth modal
  if (!user) {
    return (
      <Navigate
        to="/"
        state={{ from: location.pathname, openAuth: true }}
        replace
      />
    );
  }

  if (requiresAdmin && !isAdminEmail(user.email ?? userProfile?.email)) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
};
